// client/utils/money.js

/**
 * Format a number as currency (default CAD).
 * Returns "" for non-finite inputs so UIs stay clean.
 */
export function money(value, { currency = "CAD", locale = "en-CA" } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  // Use Intl for grouping/rounding; fixed to 2 decimals.
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}

/**
 * Simple $X.YY without Intl (fallback / testing).
 */
export function moneySimple(value) {
  const n = Number(value);
  return Number.isFinite(n) ? `$${n.toFixed(2)}` : "";
}
